<template>
  <div class="page">
    <div class="locations-grey locations-generic used">
      <div>
        Tandem and single kayaks. Pedal boats and v hull fishing boats also
        available.
      </div>
      <br />
      <a>
        Contact
        <a href="Jeff@ChicagoRiverPaddle.com">Jeff@ChicagoRiverPaddle.com</a>
        for models and pricing.
      </a>
      <br /><br />

      <div class="cove">
        <a href="https://www.confluenceoutdoor.com/en-us/products/cove-145-t-recreational-kayak/9331030042"><u>Cove specs</u></a> Priced from $300
        <br />
        <img class="cove" src="../../assets/Cove specs.jpg" />
        <br /><br />
      </div>

      <div class="touryak">
        <a href="https://www.canoeskayaks.com/shop/Kayaks/p/Prijon-Touryak-500-with-rudder-x86680619.htm"><u>Touryak specs</u></a> Priced from $600
        <br />
        <img class="touryak" src="../../assets/Touryak.jpg" />
        <br /><br />
      </div>

      <div class="dayliner" src="../../assets/Dayliner.jpg">
        <a href="https://www.canoeskayaks.com/shop/Kayaks/p/Prijon-Dayliner-S-x86680650.htm"><u>Dayliner specs</u></a> Priced from $200
        <br />
        <img class="dayliner" src="../../assets/Dayliner.jpg" />
        <br /><br />
      </div>

      <div class="heron" src="../../assets/Heron.jpg">
        <a href="https://oldtownwatercraft.johnsonoutdoors.com/us/shop/kayaks/recreation/twin-heron"><u>Heron specs</u></a> Priced from $100
        <br />
        <img class="heron" src="../../assets/Heron.jpg" />
        <br /><br />
      </div>

      <div class="seayak" src="../../assets/Seayak.jpg">
        <a href="https://en.prijon.com/seayak-classic-2.html"><u>Seayak specs</u></a> Priced from $600
        <br />
        <img class="seayak" src="../../assets/Seayak.jpg" />
        <br /><br />
      </div>

         <div class="oldtownvapor" src="../../assets/OldTownVapor.jpg">
        <a href="https://oldtownwatercraft.johnsonoutdoors.com/us/shop/kayaks/fishing/vapor-12-angler?srsltid=AfmBOoohI9rK5CrRoo2fw2VrU1LAWqS1POkr4RHRl06J2EPlKpLKW-FE"><u>Old Town Vapor specs</u></a> Priced from $100
        <br />
        <img class="oldtownvapor" src="../../assets/OldTownVapor.jpg" />
        <br /><br />
      </div>

         <div class="perceptioncarolina14" src="../../assets/PerceptionCarolina14.jpg"> 
        <a href="https://www.kayakcentre.com/carolina-14.html?srsltid=AfmBOorhZHPivob0F6f20GzOuIqrzdu5NJxQDfkw6jrJuFTvioy_hyb9"><u>Perception Carolina 14 specs</u></a> Priced from $200
        <br />
        <img class="perceptioncarolina14" src="../../assets/PerceptionCarolina14.jpg" />
        <br /><br />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "used",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cove {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.touryak {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.dayliner {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.heron {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.seayak {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.oldtownvapor {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.perceptioncarolina14 {
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.links {
  width: 80%;
}
@media screen and (max-width: 768px) {
  .links {
    width: 90%;
  }
}
.page {
  background-image: url("../../assets/pic13.png");
  flex-direction: column;
  padding-left: 20px;
  align-items: center;
}
section {
  margin-bottom: 10px;
}
a:hover {
  color: #c0504d;
}
a {
  color: White;
}
</style>
